import { actions } from 'react-redux-form';
import { httpPost, httpGet } from '../../../../../utils/api.utils';
import { getRequestUserSessionData as getUserData, convertStringBoolToBoolean } from '../../../../../utils/helpers.utils';
import { EQUIPMENT_TYPE as EquipmentType } from '../../../../../utils/constant.utils';
import { getAddresses, getUserLocation } from '../../order-request.functions';
import {
    //model
    wirelessAccessoryModel
    //action
    , setUserLocation
    , setAddressOptions
    , setBusinessCaseOptions
    , setCountryOptions
    , setDeviceAccessories
    , setFormSubmitted
    , setSubscriptionDetails
    , setFormLoading
    , setResetLoading
} from './../../../../../constants/model-reducers/external/request/wireless-request/wireless-accessory.settings';
import { BUSINESS_CASE } from '../../../../../constants/external-constants';

export const accessoryModelInitialState = wirelessAccessoryModel;

const defaultState = () => ({
    subscription: {}
    , userLocation: {}
    , countryOptions: []
    , addressOptions: []
    , equipmentOptions: []
    , deviceAccessories: []
    , businessCaseOptions: []
    , formSubmitted: false
    , isFormLoading: false
    , isResetLoading: false
});

const initialState = defaultState();

export const wirelessAccessoryActions = {
    setLoadForm: (isLoad = false) => (dispatch, state) => {
        dispatch({
            type: setFormLoading,
            data: isLoad
        });
    },
    onLoadUpdateAccessoryRequest: (subscriptionList, circuitCodePropName) => async (dispatch, state) => {
        const { requestData } = state().requestDetail;

        dispatch(actions.reset('wirelessAccessoryForm'));

        if (requestData.Circuit.CircuitCode) {
            dispatch(actions.change("wirelessAccessoryForm.circuitCode", requestData.Circuit.CircuitCode));
            dispatch(actions.change('wirelessAccessoryForm.circuitId', requestData.Circuit.CircuitId));

            dispatch(actions.change('wirelessAccessoryForm.countryCode', requestData.BillingAddress.CountryCode ?? ""));

            dispatch(actions.change('wirelessAccessoryForm.billingLocationAddressId', requestData.BillingAddress.LocationId));
            dispatch(actions.change('wirelessAccessoryForm.deliveryAddress', requestData.BillingAddress.DeliveryAddress ?? ""));
            dispatch(actions.change('wirelessAccessoryForm.otherLocationAddress', requestData.OtherLocationName ?? ""));

            dispatch(actions.change('wirelessAccessoryForm.businessCaseId', requestData.BusinessJustification.BusJustiCodeDetailId));
            dispatch(actions.change('wirelessAccessoryForm.DetailName', requestData.BusinessJustification.DetailName ?? ""));

            dispatch(actions.change('wirelessAccessoryForm.businessJustification', requestData.BusinessJustification.BusinessJustification ?? ""));
            dispatch(actions.change('wirelessAccessoryForm.additionalInformation', requestData.BusinessJustification.AdditionalInformation ?? ""));

            var subscription = subscriptionList.find(o => o[circuitCodePropName] === requestData.Circuit.CircuitCode);
            dispatch({ type: setSubscriptionDetails, data: subscription });

            let isVip = requestData.RequestedInBeHalfOf ? requestData.RequestedInBeHalfOf.Vip : getUserData().vip
            await getDeviceAccessories(dispatch, requestData.Subscription.VendorDetailId, isVip);
            
        }
        else {
            dispatch(actions.reset('wirelessAccessoryForm'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }
    },
    getAccessoryFormData: () => (dispatch, state) => {
        const { requestTypeId } = state().createRequest;
        getUserLocation(dispatch, setUserLocation, requestTypeId);
        getCountries(dispatch);
        //getDeviceTypes(dispatch);
        getBusinessCases(dispatch);
    }
    , onSubscriptionSelect: (value, propsName, objects, index) => async (dispatch, state) => {
        const { wirelessAccessoryForm } = state().form;
        const { isRequestOnBehalf, requestOnBehalfData, takeActionCircuitId } = state().createRequest;

        let isVip = isRequestOnBehalf ? requestOnBehalfData.Vip : getUserData().vip;

        if (value === '' || !propsName) {
            dispatch(actions.reset('wirelessAccessoryForm'));
            dispatch({ type: setSubscriptionDetails, data: {} });
            dispatch({ type: setDeviceAccessories, data: [] });
        } else {
            if(propsName) {               
                var obj=null              
                if(objects !== null && objects !== undefined) {
                    if(index !== -1 && index !== undefined && index !== null) {
                        obj=objects[index]
                    }
                    else if(objects.length === 1) {
                        obj=objects.find(o => o[propsName] === value);
                    }
                    else if (objects.length > 1) {
                        obj = objects.find(o => o[propsName] === value & o['CircuitId'] === takeActionCircuitId);
                    }  
                    await getDeviceAccessories(dispatch, obj.VendorDetailId, isVip);
                } 
                if (obj != null && obj.CircuitId != wirelessAccessoryForm.circuitId) {
                    dispatch(actions.reset('wirelessAccessoryForm'));
                    dispatch(actions.change('wirelessAccessoryForm.circuitCode', value));
                    dispatch(actions.change('wirelessAccessoryForm.circuitId', obj.CircuitId));
                    dispatch({ type: setSubscriptionDetails, data: obj });
                    getCountries(dispatch);
                    await getDeviceAccessories(dispatch, obj.VendorDetailId, isVip);
    
                }
            }
        }
    }
    , setRequestorAddress: () => (dispatch, state) => {

        const { showOtherAddress, userLocation } = state().wirelessAccessoryRequest;
        const { requestOnBehalfData } = state().createRequest;

        var location = {
            ...userLocation
        };

        if (requestOnBehalfData.EmployeeId > 0) {
            location = {
                ...requestOnBehalfData.LocationModel
            };
        }

        getAddresses(dispatch, setAddressOptions, location.CountryCode, showOtherAddress);

        dispatch(actions.change('wirelessAccessoryForm.countryCode', location.CountryCode));
        dispatch(actions.change('wirelessAccessoryForm.billingLocationAddressId', location.LocationId));
        dispatch(actions.change('wirelessAccessoryForm.deliveryAddress', location.DeliveryAddress));
        dispatch(actions.change('wirelessAccessoryForm.otherLocationAddress', ''));

    }
    , onAccessorySelect: (e) => async (dispatch, state) => {

        const { deviceAccessories } = state().wirelessAccessoryRequest;
        const { wirelessAccessoryForm } = state().form;
        var selectedObj = deviceAccessories.find(x => x.EquipmentInventoryId == e.target.value);
        var newAccessories = [...wirelessAccessoryForm.accessoryDetailsModel];

        if (e.target.checked) {
            newAccessories.push(selectedObj);
        } else {

            const indexOfObject = wirelessAccessoryForm.accessoryDetailsModel.findIndex(o => {
                return o.EquipmentInventoryId == e.target.value;
            });

            newAccessories.splice(indexOfObject, 1);
        }

        dispatch(actions.change('wirelessAccessoryForm.accessoryDetailsModel', newAccessories));
    }
    , onCountrySelect: (model, value) => async (dispatch, state) => {

        const { countryOptions } = state().wirelessAccessoryRequest;

        dispatch(actions.change(model, value));

        let country = countryOptions.find(o => o['Key'] === value).Value;
        dispatch(actions.change('wirelessAccessoryForm.country', country));
        dispatch(actions.change('wirelessAccessoryForm.billingLocationAddressId', ''));
        dispatch(actions.change('wirelessAccessoryForm.deliveryAddress', ''));
        dispatch(actions.change('wirelessAccessoryForm.otherLocationAddress', ''));

        getAddresses(dispatch, setAddressOptions, value, true);

    }
    , onAddressSelect: (model, value) => async (dispatch, state) => {

        const { addressOptions } = state().wirelessAccessoryRequest;

        dispatch(actions.change(model, value));

        if (model == 'wirelessAccessoryForm.billingLocationAddressId') {
            const deliveryAddress = addressOptions.length > 0 ? addressOptions.find(r => r.Key == value).Value : '';
            dispatch(actions.change('wirelessAccessoryForm.deliveryAddress', deliveryAddress));
            dispatch(actions.change('wirelessAccessoryForm.otherLocationAddress', ''));
        }

    }
    , onBusinessCaseSelect: (model, value) => async (dispatch, state) => {

        dispatch(actions.change(model, value));

        const { businessCaseOptions } = state().wirelessAccessoryRequest;

        let businessCase = parseInt(value) !== BUSINESS_CASE.other ? businessCaseOptions.find(o => o['Key'] == value).Value : "";
        dispatch(actions.change('wirelessAccessoryForm.businessJustification', businessCase));

    }
    , submitRequest: () => async (dispatch, state) => {

        const { wirelessAccessoryForm } = state().form;
        const { requestTypeId, isRequestOnBehalf, requestOnBehalfData, isUpdateRequest } = state().createRequest;
        const { subscription } = state().wirelessAccessoryRequest;

        let userData = getUserData();

        if (isRequestOnBehalf) {
            userData.requestInBehalfId = requestOnBehalfData.EmployeeId;
            userData.vip = requestOnBehalfData.Vip;
        }

        userData.managerApproverId = isRequestOnBehalf ?
            requestOnBehalfData.CostCodeApproverEmployeeId : sessionStorage.CostCodeAuthorizerID;

        let changeRequestData = {
            ...userData
            , ...wirelessAccessoryForm
            , VendorDetailId: subscription.VendorDetailId
            , RequestTypeId: requestTypeId
        }

        if (isUpdateRequest) {
            const { requestData } = state().requestDetail;

            changeRequestData = {
                ...changeRequestData,
                OrderId: requestData.Order.OrderId,
                OrderInfoId: requestData.OrderInfoId,
                CircuitOrderId: requestData.CircuitOrderId,
                OrderHistoryId: requestData.OrderHistoryId
            }
        }

        var data = {
            ChangeRequestModel: changeRequestData,
            IsAmending: isUpdateRequest,
            CountryCode: wirelessAccessoryForm.countryCode,
            DeliveryAddressID: wirelessAccessoryForm.billingLocationAddressId
        };


        dispatch({ type: setFormSubmitted, data: true });

        var res = await httpPost('external/accessoryRequest/submitAccessoryRequest', data);

        if (!(res.Success)) {
            dispatch({ type: setFormSubmitted, data: false });
        }

        return res;

    }
    , resetWirelessAccessoryForm: (isResetRequestOnBehalf = false) => (dispatch, state) => {

        const { takeActionCircuitCode } = state().createRequest;
        if((takeActionCircuitCode !== '' && takeActionCircuitCode !== undefined && takeActionCircuitCode !== null) && isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: false });
            return;
        }
        if (isResetRequestOnBehalf) {
            dispatch({ type: setResetLoading, data: true });
            dispatch(actions.reset('wirelessAccessoryForm.circuitCode'));
            dispatch(actions.reset('wirelessAccessoryForm.circuitId'));
            dispatch({ type: setSubscriptionDetails, data: {} });

            getCountries(dispatch);

            setTimeout(function () {
                dispatch({ type: setResetLoading, data: false });
            }, 5);
        }
        else if (!isResetRequestOnBehalf) {
            dispatch(actions.reset('wirelessAccessoryForm'));
            dispatch({ type: setSubscriptionDetails, data: {} });
        }

        dispatch(actions.reset('wirelessAccessoryForm'));
        dispatch({ type: setFormSubmitted, data: false });
    }
    , setAccessoryDetailsModel: (accessoryDetailsModel) => (dispatch) => {
        dispatch(actions.change('wirelessAccessoryForm.accessoryDetailsModel', accessoryDetailsModel));
    }
}

async function getCountries(dispatch) {
    var res = await httpPost('external/replaceDevice/getCountriesList');
    if (res != null) {
        dispatch({ type: setCountryOptions, data: res });
    } else {
        dispatch({ type: setCountryOptions, data: { ...defaultState.countryOptions } });
    }

    if (res.length == 1) {
        dispatch(actions.change('wirelessAccessoryForm.countryCode', res[0].Key));
        getAddresses(dispatch, setAddressOptions, res[0].Key);
    }
}

async function getDeviceAccessories(dispatch, vendorId, vip)  {
    var res = await httpGet('external/orderRequest/getEquipmentByVIPStatus/' + vendorId + '/' + EquipmentType.Accessory + '/' + convertStringBoolToBoolean(vip));

    dispatch({ type: setDeviceAccessories, data: res.datatable });
}

//async function getDeviceTypes(dispatch) {
//    var res = await httpGet('external/replaceDevice/getAllDeviceTypes');

//    if (res != null) {
//        dispatch({ type: setEquipmentOptions, data: res });
//    } else {
//        dispatch({ type: setEquipmentOptions, data: { ...defaultState.equipmentOptions } });
//    }
//}

async function getBusinessCases(dispatch) {
    var res = await httpPost('external/replaceDevice/getBusinessCases');

    if (res != null) {
        dispatch({ type: setBusinessCaseOptions, data: res });
    } else {
        dispatch({ type: setBusinessCaseOptions, data: { ...defaultState.businessCaseOptions } });
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setUserLocation:
            return {
                ...state,
                userLocation: action.data
            };
        case setCountryOptions:
            return {
                ...state
                , countryOptions: action.data
            };
        case setAddressOptions:
            return {
                ...state
                , addressOptions: action.data
            };
        case setBusinessCaseOptions:
            return {
                ...state
                , businessCaseOptions: action.data
            };
        case setDeviceAccessories:
            return {
                ...state,
                deviceAccessories: action.data
            };
        case setSubscriptionDetails:
            return {
                ...state
                , subscription: { ...action.data }
            };
        case setFormSubmitted:
            return {
                ...state
                , formSubmitted: action.data
            };
        case setFormLoading:
            return {
                ...state
                , isFormLoading: action.data
            };
        case setResetLoading:
            return {
                ...state
                , isResetLoading: action.data
            };
        default: return state;
    }
}